import {
  Button,
  Dialog,
  DialogContent,
  Grid2,
  IconButton,
  Typography,
} from "@mui/material";
import { IconX } from "@tabler/icons-react";
import { toast } from "react-toastify";
import Loading from "./Loading";
import { useMutation } from "@tanstack/react-query";
import { studentDisable, studentEnable } from "../services/students";

const StudentEnableOrDisable = ({
  open,
  onClose,
  id,
  status,
  onAction,
}: {
  open: boolean;
  onClose: () => void;
  id: string | number;
  status: string;
  onAction: () => void;
}) => {
  const { mutate, isPending } = useMutation({
    mutationFn: studentDisable,
    onSuccess: () => {
      onClose();
      onAction();
      toast.success("Aluno bloqueado");
    },

    onError: (e: { response: { data: { message: string } } }) => {
      toast.error(String(e?.response?.data?.message) || "Erro!");
    },
  });

  const { mutate: mutateEnable, isPending: isPendingEnable } = useMutation({
    mutationFn: studentEnable,
    onSuccess: () => {
      onClose();
      onAction();
      toast.success("Aluno desbloqueado");
    },

    onError: (e: { response: { data: { message: string } } }) => {
      toast.error(String(e?.response?.data?.message) || "Erro!");
    },
  });

  return (
    <Dialog maxWidth="xs" open={open} onClose={() => onClose()}>
      <Loading loading={isPending || isPendingEnable} />
      <DialogContent sx={{ backgroundColor: "secondary.main" }}>
        <Grid2 container spacing={2} padding={1}>
          <Grid2 size={{ xs: 10, md: 11 }}>
            <Typography variant="h2" fontSize={26} fontWeight={600}>
              {status === "DISABLED" ? "Desbloquear aluno" : "Bloquear aluno"}
            </Typography>
          </Grid2>
          <Grid2 size={{ xs: 2, md: 1 }}>
            <IconButton onClick={() => onClose()}>
              <IconX style={styles.iconStyle} />
            </IconButton>
          </Grid2>
          <Grid2 size={12}>
            <Typography variant="subtitle1" color="theme.contrastText">
              {status === "DISABLED"
                ? "Você deseja desbloquear este aluno?"
                : "Você deseja bloquear este aluno?"}
            </Typography>
          </Grid2>
          <Grid2 size={12}>
            <Button
              fullWidth
              variant="contained"
              size="large"
              sx={{ backgroundColor: "red" }}
              onClick={() =>
                status === "DISABLED" ? mutateEnable({ id }) : mutate({ id })
              }
            >
              {status === "DISABLED" ? "Desbloquear aluno" : "Bloquear aluno"}
            </Button>
          </Grid2>
        </Grid2>
      </DialogContent>
    </Dialog>
  );
};

const styles = {
  stackStyle: {
    flexDirection: "row",
    alignItems: "center",
    gap: 1,
    padding: 1,
    borderRadius: 2,
    backgroundColor: "secondary.dark",
  },
  iconStyle: {
    color: "primary.main",
  },
};

export default StudentEnableOrDisable;
